import React from "react";
import { Table, List, Space, Row, Col, Typography } from "antd";
import { ListRecordAttributeItem } from 'components';
import moment from 'moment';

const { Column } = Table;
const { Title, Text, Link } = Typography;

const displayLabels = {
    "name": "API Key",
    "canAdd": "Add",
    "canView": "View",
    "canEdit": "Edit",
    "canDelete": "Delete",
    "active": "Active",
    "updatedByEmail": "Updated by",
    "updatedDate": "Updated at",
    "deleted": "Deleted"
}

function parseAction(apiKey) {
    if (apiKey && apiKey.actions) {
        apiKey.canAdd = false;
        apiKey.canView = false;
        apiKey.canEdit = false;
        apiKey.canDelete = false;
        if (apiKey.actions.includes("add")) {
            apiKey.canAdd = true;
        }
        if (apiKey.actions.includes("view")) {
            apiKey.canView = true;
        }
        if (apiKey.actions.includes("edit")) {
            apiKey.canEdit = true;
        }
        if (apiKey.actions.includes("delete")) {
            apiKey.canDelete = true;
        }
        delete apiKey.actions;
    }
}

export default function ({ record }) {
    let currentData = { ...record.data };
    let previousData = { ...(record.previousData || {}) };
    if (currentData && currentData.apiKey) {
        parseAction(currentData.apiKey);
    }
    if (previousData && previousData.apiKey) {
        parseAction(previousData.apiKey);
    }
    return <>
        <Row className="middle-row">
            <Col span={24}>
                <Title level={5}><Text>{record.name}</Text></Title>
            </Col>
        </Row>
        <Row>
            <Col span={24}>
                <List
                    size="small"
                    bordered
                    dataSource={Object.keys(currentData)}
                    renderItem={item => {
                        if (item === "apiKey") {
                            let currentUserItem = currentData["apiKey"];
                            let previousUserItem = previousData && previousData["apiKey"];
                            return Object.keys(currentUserItem).map(userKey => {
                                if (displayLabels[userKey]) {
                                    return <ListRecordAttributeItem name={displayLabels[userKey]} value={currentUserItem[userKey]} previousValue={previousUserItem && previousUserItem[userKey]}></ListRecordAttributeItem>
                                }
                                return <></>
                            });
                        }
                        if (displayLabels[item]) {
                            if (item === "updatedDate") {
                                return <ListRecordAttributeItem name={displayLabels[item]} value={moment.utc(currentData[item]).toDate().toLocaleString()} previousValue={previousData[item] && moment.utc(previousData[item]).toDate().toLocaleString()}></ListRecordAttributeItem>
                            }
                            return <ListRecordAttributeItem name={displayLabels[item]} value={currentData[item]} previousValue={previousData && previousData[item]}></ListRecordAttributeItem>
                        }
                        return <></>
                    }}
                />
            </Col>
        </Row>
    </>
}